var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIconButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.26357 2.26357C3.72326 0.803883 5.66399 0 7.72826 0C9.79253 0 11.7333 0.803883 13.1929 2.26357C14.6526 3.72322 15.4565 5.66395 15.4565 7.72819C15.4565 9.61548 14.7842 11.3992 13.5534 12.8068L17.8454 17.0988C18.0515 17.305 18.0515 17.6392 17.8454 17.8454C17.7423 17.9484 17.6072 18 17.4721 18C17.3371 18 17.2019 17.9485 17.0989 17.8453L12.8069 13.5534C11.3993 14.7841 9.61555 15.4564 7.72826 15.4564C5.66395 15.4564 3.72329 14.6526 2.26361 13.1929C0.803953 11.7332 7.05719e-05 9.79249 7.05719e-05 7.72822C7.05719e-05 5.66395 0.803919 3.72322 2.26357 2.26357ZM3.01015 12.4463C5.61175 15.0479 9.84473 15.0479 12.4463 12.4463C15.0479 9.84477 15.0479 5.61171 12.4463 3.01015C11.1454 1.70923 9.4371 1.05898 7.72822 1.05898C6.01977 1.05898 4.31075 1.70954 3.01011 3.01015C0.408621 5.61168 0.408621 9.84473 3.01015 12.4463Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIconButton);
export default __webpack_public_path__ + "static/media/SearchIconButton.da314fab5fb1c1ec017dde779b6fdd2c.svg";
export { ForwardRef as ReactComponent };